import React, {useRef, useEffect, useState, useCallback, useMemo} from 'react';
import {ActionIcon} from "@mantine/core";
import {IconStar} from "@tabler/icons";
import useFirebaseFunction from "../utils/useFirebaseFunction";

export default function ButonEvidentiaza({image, board}) {

    const [featured, setFeatured] = useState(!!image?.featured);
    const [feature_photos, isFeaturePhotosLoading] = useFirebaseFunction("feature_photos", "europe-west1");

    const doSomething = (e) => {
        e.preventDefault();
        e.stopPropagation()
        feature_photos({board, photos: [image?.id], action: !featured});
        setFeatured(!featured);
    }

    const stylesIconInactive = {
        root: {
            color:'#fff',
            backgroundColor:'#3C3C3C',

            '&:hover' : {
                backgroundColor:'#7D7D7D',
                color:'#fff'
            }
        }
    }

    const stylesIconActive = {
        root: {
            color:'#FFD700',
            backgroundColor:'#3C3C3C',

            '&:hover': {
                backgroundColor:'#7D7D7D',
                color:'#FFD700'
            }
        }
    }


    return useMemo(() => {
        return (
            <div className={'image-actions'}>
                <ActionIcon radius="xl" styles={featured ? stylesIconActive : stylesIconInactive} color="dark" size="md" onClick={doSomething}>
                    <IconStar fill={featured ? '#FFD700' : 'none'} size={20} />
                </ActionIcon>
            </div>
        )
    }, [image?.id, featured, board])

}
